import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './pages/home/home.component';
import { AboutUsComponent } from './pages/about-us/about-us.component';
import { AcademicComponent } from './pages/academic/academic.component';
import { GalleryComponent } from './pages/gallery/gallery.component';
import { PubDisclosureComponent } from './pages/pub-disclosure/pub-disclosure.component';
import { ContactComponent } from './pages/contact/contact.component';
import { NewsComponent } from './pages/news/news.component';
import { DirectorMsgComponent } from './pages/about-us/director-msg/director-msg.component';
import { CurriculamComponent } from './pages/curriculam/curriculam.component';
import { DressesComponent } from './pages/dresses/dresses.component';
import { FeesComponent } from './pages/fees/fees.component';
import { SchGuidelinesComponent } from './pages/sch-guidelines/sch-guidelines.component';
import { ViewNewsComponent } from './pages/news/view-news/view-news.component';
import { AboutUsV2Component } from './pages/about-us/about-us-v2/about-us-v2.component';

const routes: Routes = [
  { path:"", redirectTo: "/home", pathMatch: "full"},
  { path : 'home' , component : HomeComponent},
  { path : 'aboutUs' , component : AboutUsComponent},
  {
    path: 'aboutUs-v2',
    component: AboutUsV2Component
  },
  { path : 'academic' , component : AcademicComponent},
  { path : 'curriculum' , component : CurriculamComponent},
  { path : 'guidelines' , component : SchGuidelinesComponent},
  { path : 'gallery' , component : GalleryComponent},
  { path : 'pubDis' , component : PubDisclosureComponent},
  { path : 'contact' , component : ContactComponent},
  { path : 'news' , component : NewsComponent},
  { path : 'directorMsg' , component : DirectorMsgComponent},
  { path : 'dresses' , component : DressesComponent},
  { path : 'online-fees' , component : FeesComponent},
  { path : 'newspage1' , component : ViewNewsComponent},
  { path : '**' , redirectTo: "/home" },

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
